import { Flex, Image, Typography } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

interface Moment {
  id: string;
  url: string;
}

interface MomentsProps {
  moments: Moment[];
}

const MomentPicture = styled(Image)`
  object-fit: cover;
  object-position: center;
  border-radius: 10px;

  && {
    max-height: 220px;
    max-width: 100%;
    height: auto;
    width: auto;
  }
`;

const Group = styled(Flex)`
  .ant-image-mask {
    border-radius: 10px;
  }
`;

const Moments = function ({ moments }: MomentsProps) {
  const { t } = useTranslation();

  if (!moments?.length) return null;

  return (
    <>
      <Typography.Title level={4} style={{ margin: 0 }}>
        {t('chat:::communityMomentsTitle')}
      </Typography.Title>
      <Typography.Paragraph type="secondary">
        {t('chat:::communityMomentsDescription')}
      </Typography.Paragraph>
      <Group gap="small">
        <Image.PreviewGroup preview={{ actionsRender: () => null }}>
          {moments.map(({ id, url }) => (
            <MomentPicture key={id} src={url} />
          ))}
        </Image.PreviewGroup>
      </Group>
    </>
  );
};

export default Moments;
